module.exports = __webpack_public_path__ + "static/media/Move Up Blue.cb32e28c.svg";